import React, {useEffect, useState} from "react";
import {AccountCircle} from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import {useAuthentication} from "../../auth/AuthProvider";
import {useTranslation} from "react-i18next";
import {run} from "../../utils/function-util";
import * as _ from 'lodash';
import {UserInfo} from "../../models/user-info.model";

const useStyles = makeStyles(theme => ({
    userProfileToggle: {
        'display': 'flex',
        'padding': '5px',
        'align-items': 'center',
        ...theme.mixins.toolbar
    },
    userName: {
        'overflow': 'hidden'
    }
}));

const UserProfileToggle = () => {
    const languages = {en: {key: 'en', value: 'English'}, fr: {key: 'fr', value: 'Français'}};
    const {i18n, t} = useTranslation();
    const checkLanguageKey = (langKey: any) => _.get(languages, [langKey, 'key'], i18n.language);

    const {getUser, logout} = useAuthentication();
    const [user, setUser] = useState<UserInfo>();
    const [language, setLanguage] = useState(i18n.language);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const classes = useStyles();

    useEffect(run(getUser, setUser), [getUser]);

    useEffect(() => _.flow(_.partialRight(_.get, 'Language'), _.toLower, checkLanguageKey, changeLanguage)(user), [user]);

    const handleMenu = (event: any) => setAnchorEl(event.currentTarget);

    const handleClose = () => setAnchorEl(null);

    const getOppositeLanguage = () => language === languages.fr.key ? languages.en : languages.fr;

    const changeLanguage = (langKey: any) => {
        setLanguage(langKey);
        i18n.changeLanguage(langKey);
    };

    return <div className={classes.userProfileToggle}>
        {user ? <Typography variant="body2" noWrap>{user.FirstName} {user.LastName}</Typography> : null}
        <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
        >
            <AccountCircle/>
        </IconButton>
        <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={open}
            onClose={handleClose}
        >
            <MenuItem onClick={() => changeLanguage(getOppositeLanguage().key)}>
                {getOppositeLanguage().value}
            </MenuItem>
            <MenuItem>
                <a href={t("_Common.UserMenu.Tutorial.Url")}
                   target={'_blank'}>{t("_Common.UserMenu.Tutorial.Label")}</a>
            </MenuItem>
            <MenuItem onClick={logout}>{t("_Common.UserMenu.Logout")}</MenuItem>
        </Menu>
    </div>
}

export default UserProfileToggle;
